// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as ProtectedExampleProtectedRouteRouteImport } from './routes/_protected/example-protected-route'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthSignOutRouteImport } from './routes/_auth/sign-out'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'

const PublicRoute = PublicRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const ProtectedRoute = ProtectedRouteImport.update({
            id: '/_protected',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const PublicIndexRoute = PublicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicRoute
          })
const ProtectedExampleProtectedRouteRoute = ProtectedExampleProtectedRouteRouteImport.update({
            id: '/example-protected-route',path: '/example-protected-route',getParentRoute: () => ProtectedRoute
          })
const AuthSignUpRoute = AuthSignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => AuthRoute
          })
const AuthSignOutRoute = AuthSignOutRouteImport.update({
            id: '/sign-out',path: '/sign-out',getParentRoute: () => AuthRoute
          })
const AuthSignInRoute = AuthSignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => AuthRoute
          })





const AuthRouteChildren = {
  AuthSignInRoute: AuthSignInRoute,AuthSignOutRoute: AuthSignOutRoute,AuthSignUpRoute: AuthSignUpRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const ProtectedRouteChildren = {
  ProtectedExampleProtectedRouteRoute: ProtectedExampleProtectedRouteRoute
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(ProtectedRouteChildren)




const PublicRouteChildren = {
  PublicIndexRoute: PublicIndexRoute
}

const PublicRouteWithChildren = PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,ProtectedRoute: ProtectedRouteWithChildren,PublicRoute: PublicRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)